import { CardPreference } from '@orientaction/components';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { dataPreference, publicSvgPath } from '@orientaction/utils';
import { FC, useState } from 'react';
import FirstView from '../../../../../PageResultat/ResultatPreference/FirstView';
import ModalCardPref from '../components/DetailModal/PreferenceDetailModal';
import ResultDetailCard from '../components/ResultDetailCard';
import { DetailsSection } from '../components/SummarySection';
import { useMajorResultStyles } from '../MajorResult.styles';
import { MajorTestContentProps } from '../types';
import {
  getPreferenceExcerpt,
  getPreferenceLabelColor,
  getPreferenceScore,
  preferenceImages,
  preferenceRankColors,
} from './preferencePresentation';
import PreferenceSummary from './PreferenceSummary';

type PreferenceContentProps = MajorTestContentProps & {
  isPrefJeune?: boolean;
  resultId?: number;
  onResultUpdated?: () => void;
};

const PreferenceContent: FC<PreferenceContentProps> = ({
  myResult,
  isPrefJeune = false,
  resultId,
  onResultUpdated,
}) => {
  const classes = useMajorResultStyles();
  const [selectedPreference, setSelectedPreference] = useState<any>(null);
  const preferences = myResult?.resultat || [];

  if (isPrefJeune) {
    return (
      <>
        <FirstView
          listPrincipaux={preferences}
          id={resultId ? String(resultId) : undefined}
          handleUpdated={onResultUpdated ? () => onResultUpdated() : undefined}
          consultant={myResult?.consultant}
          updatedDate={myResult?.updatedDate}
          upperHierarchie={myResult?.user?.upper_hierarchy?.id}
          isPrefJeune={true}
          initValue={myResult?.initValue}
        />
        <DetailsSection title="DÉCOUVREZ VOS PRÉFÉRENCES">
          {preferences.map((pref: any) => (
            <div key={pref.category}>
              <CardPreference pref={pref} />
            </div>
          ))}
        </DetailsSection>
      </>
    );
  }

  const selectedContent = dataPreference[selectedPreference?.category]?.[selectedPreference?.key];

  return (
    <>
      <PreferenceSummary
        myResult={myResult}
        resultId={resultId}
        onResultUpdated={onResultUpdated}
        onSelect={setSelectedPreference}
      />

      <DetailsSection title="DÉCOUVREZ VOS PRÉFÉRENCES">
        {preferences.map((pref: any, index: number) => {
          const content = dataPreference[pref.category]?.[pref.key];
          const color = preferenceRankColors[index];
          return (
            <ResultDetailCard
              key={pref.category}
              label={pref.title}
              color={color}
              labelColor={getPreferenceLabelColor(index)}
              imageSrc={preferenceImages[pref.key] || `${publicSvgPath}/${content?.img}`}
              imageAlt={pref.label}
              title={`Vous êtes ${pref.youAre}.`}
              subtitle={getPreferenceExcerpt(content?.text1)}
              onLearnMore={() => setSelectedPreference(pref)}
              imageOverlay={
                <div className={classes.scoreBadge}>
                  <CircularProgressCustom
                    value={getPreferenceScore(pref)}
                    color={color}
                    size={78}
                    fontSize={18}
                    fontSizeFloat={12}
                    isPercent={true}
                  />
                </div>
              }
            />
          );
        })}
      </DetailsSection>

      {selectedPreference && (
        <ModalCardPref
          open={true}
          onCancel={() => setSelectedPreference(null)}
          color={
            preferenceRankColors[
              preferences.findIndex((pref: any) => pref.category === selectedPreference.category)
            ]
          }
          img={
            preferenceImages[selectedPreference.key] || `${publicSvgPath}/${selectedContent?.img}`
          }
          label={selectedPreference.label}
          title={selectedPreference.title}
          colorSecondary={dataPreference[selectedPreference.category]?.secondColor}
          opacity={!!dataPreference[selectedPreference.category]?.opacity}
          value={getPreferenceScore(selectedPreference)}
          text1={selectedContent?.text1}
          text2={selectedContent?.text2}
          list1={selectedContent?.list1}
          list2={selectedContent?.list2}
          youAre={selectedPreference.youAre}
          listText={selectedContent?.listText}
        />
      )}
    </>
  );
};

export default PreferenceContent;
